import { formatCnpj } from '@/_helpers/cnpj'
import { Link } from '@tanstack/react-router'
import type { ColumnDef } from '@tanstack/react-table'

import { formatDate } from '../_helpers/date'

export const companyColumns: ColumnDef<any>[] = [
  {
    accessorKey: 'name',
    header: 'Nome Fantasia',
    cell: ({ row }) => {
      return (
        <Link
          to="/companies/$companySlug/facilities"
          params={{ companySlug: row.original.slug }}
          className="inline-flex w-full px-8 py-3"
        >
          <span>{row.original.name}</span>
        </Link>
      )
    },
  },
  {
    accessorKey: 'cnpj',
    header: 'CNPJ',
    cell: ({ row }) => {
      return (
        <Link
          to="/companies/$companySlug/facilities"
          params={{ companySlug: row.original.slug }}
          className="inline-flex w-full px-8 py-3"
        >
          <span>{row.original.cnpj ? formatCnpj(row.original.cnpj) : '—'}</span>
        </Link>
      )
    },
  },
  {
    accessorKey: 'createdAt',
    header: 'Data de Criação',
    cell: ({ row }) => {
      return (
        <Link
          to="/companies/$companySlug/facilities"
          params={{ companySlug: row.original.slug }}
          className="flex w-full px-8 py-3"
        >
          <span>{row.original.createdAt ? formatDate(row.original.createdAt) : '—'}</span>
        </Link>
      )
    },
  },
]
